
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexRhXtSWD9xTpAAsSvd0qPuqUmDt2CgTun1XHmzvlvoFIMeta } from "/app/code/web-frontend/modules/core/pages/index.vue?macro=true";
import { default as debug7pHoKOhXt9p6e8nNIO3lg8Y3qYSrFECDtRRxp8do0sgMeta } from "/app/code/web-frontend/modules/core/pages/debug.vue?macro=true";
import { default as loginfDgo4zzaB0kfmyvxsbEPAp_45N_45oe2IDUFtOeLtqjqPwUMeta } from "/app/code/web-frontend/modules/core/pages/login.vue?macro=true";
import { default as signupfrw_45oHT0S_45vVP87g1RilbOJ0wmYIeqbXGYUgStffbSkMeta } from "/app/code/web-frontend/modules/core/pages/signup.vue?macro=true";
import { default as forgotPasswordXn3NeNvdY2cT4ItgULlVu64F0ZeZnPLfaZtDUuu9_45hoMeta } from "/app/code/web-frontend/modules/core/pages/forgotPassword.vue?macro=true";
import { default as resetPasswordddVpqr_45be986zw6O0e8cfgcN90ONKfHXGt_45JlSLcHgcMeta } from "/app/code/web-frontend/modules/core/pages/resetPassword.vue?macro=true";
import { default as changeEmailr5kwIPnkiMsdFPlpViPhOSvJdMKLgtHuIE6ex7W2pUgMeta } from "/app/code/web-frontend/modules/core/pages/changeEmail.vue?macro=true";
import { default as verifyEmailAddressLAmyeikrtHQ7He_4591wBSXRVNUVqzKgEWW2MdNtiARNYMeta } from "/app/code/web-frontend/modules/core/pages/verifyEmailAddress.vue?macro=true";
import { default as styleGuideYvL_45urj_k3sVaUJt3KrBCbogadyrUdzEkC2gRiahByUMeta } from "/app/code/web-frontend/modules/core/pages/styleGuide.vue?macro=true";
import { default as loginWithSAMLay1ZYNDzYNJckGvJiGeyXkhRi1_wpctKqt0_x9E8yh0Meta } from "/app/code/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginWithSAML.vue?macro=true";
import { default as loginErrorGhNqepWihGnZIr5IPlzWDJ0T_lcXnXEvCIVqCHhM1ioMeta } from "/app/code/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginError.vue?macro=true";
import { default as loginPagesrSNB1Hoe8vTWUFcV0cYcYoupvjA88I_45Arn2771kVhJUMeta } from "/app/code/web-frontend/modules/core/pages/loginPages.vue?macro=true";
import { default as dashboardnI2dQMFe6DIWjzPVxkHh_45cc8u26ghAQV4MzUoTewIfsMeta } from "/app/code/web-frontend/modules/core/pages/dashboard.vue?macro=true";
import { default as workspaceD1typQeDcfHyRfvySiowhyQboQLp6bNlzxSWzKSaOoMMeta } from "/app/code/web-frontend/modules/core/pages/workspace.vue?macro=true";
import { default as settingsrHG6WsrJjIKfvLhm1sRKv_kcsBT_DUoM1NSr2LCE13kMeta } from "/app/code/web-frontend/modules/core/pages/admin/settings.vue?macro=true";
import { default as healthPpH9dk4KVAuCIKr2CasVo7pdMMz0XTaJ0ZhIjgIDC60Meta } from "/app/code/web-frontend/modules/core/pages/admin/health.vue?macro=true";
import { default as dashboardNGr7VRJHxAPL_45dnXV8NFA__45yF9Bv0zckMNH5ki_ZC4oMeta } from "/app/code/web-frontend/modules/core/pages/admin/dashboard.vue?macro=true";
import { default as usersoC80kmTdMOVB3ZzDioHEViPmnppO3go7Buqf_45gayHrAMeta } from "/app/code/web-frontend/modules/core/pages/admin/users.vue?macro=true";
import { default as workspacesx_45w7jiQUA3UgIqsSBMVIz7hureIIwB6VY_45pculs5SFoMeta } from "/app/code/web-frontend/modules/core/pages/admin/workspaces.vue?macro=true";
import { default as membershxEeihpGmdN_45F2WD4KZksMvD0SE0VFTu_45HSRe3OzDIYMeta } from "/app/code/web-frontend/modules/core/pages/settings/members.vue?macro=true";
import { default as invitesccObHUzdM5JbRei5efTAK_45Td7dLb4Gzh_SxM70Ru77oMeta } from "/app/code/web-frontend/modules/core/pages/settings/invites.vue?macro=true";
import { default as teams2TnSgr6B8fVZTD_xzIOSgVSaHiRypog2KIbJm9f3_450YMeta } from "/app/code/enterprise/web-frontend/modules/baserow_enterprise/pages/settings/teams.vue?macro=true";
import { default as settingsVPvYroDo9BIiI_45NSA17_GBB1qJC4QMLsWGiExIa5nkcMeta } from "/app/code/web-frontend/modules/core/pages/settings.vue?macro=true";
import { default as authProvidersbymTLAUs7GUcT7g4_45V0i47XAPfstfSmiU01QkfhG7xwMeta } from "/app/code/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/authProviders.vue?macro=true";
import { default as auditLogn1OFBHT_45pER2yP1OpNxllkXWnVFx_NBBtYUfZIsgTZAMeta } from "/app/code/enterprise/web-frontend/modules/baserow_enterprise/pages/auditLog.vue?macro=true";
import { default as scans87SzdRBDWmGf8_45HmNjmZOxBa8M0U4pFaYfOj_45B4bZCYMeta } from "/app/code/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner/scans.vue?macro=true";
import { default as resultsBIJPI6KClsuqoMCN8B0ouri9sUpXuqJnoeBjszBSvw4Meta } from "/app/code/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner/results.vue?macro=true";
import { default as dataScannervr_45XrYUCzaAsCX_452UvcIJHoZrWA6HNNYCyXuDZ17BNUMeta } from "/app/code/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner.vue?macro=true";
import { default as rooth0fkNmr8sjr2RiV7G_45HZ_455Pk9PIovUckWDplfdfg8qoMeta } from "/app/code/web-frontend/modules/core/pages/root.vue?macro=true";
import { default as workspaceInvitationPH1Dx0zMUa3ujL3sq4PpAeCeGFdzVWBJK7ALkTSedDMMeta } from "/app/code/web-frontend/modules/core/pages/workspaceInvitation.vue?macro=true";
import { default as templateSm2aJnOvMWRrk7T0FRaz_45qjIvP54vI6HmRt_2pGG7GcMeta } from "/app/code/web-frontend/modules/core/pages/template.vue?macro=true";
import { default as _healthpWX_45nl39OCQzS3UBdD8FLFu6Jdhal96ZyNdZlrcZYQ8Meta } from "/app/code/web-frontend/modules/core/pages/_health.vue?macro=true";
import { default as notificationRedirectMSJqkBBsNWpK4QwldkobgE_459PjQ_TUsShli_45TFINeMQMeta } from "/app/code/web-frontend/modules/core/pages/notificationRedirect.vue?macro=true";
import { default as onboardingy6d12zxbTs2bFArqJTxIQhnHvO8qRnbp_5eINSD8vAoMeta } from "/app/code/web-frontend/modules/core/pages/onboarding.vue?macro=true";
import { default as RouterViewPlaceholderftOpu4QrMI5hRqREzsexz_Z6jwU88sutk01jQUnmuMoMeta } from "/app/code/web-frontend/modules/core/components/RouterViewPlaceholder.vue?macro=true";
import { default as webhooksVS_45l5C_45mrSLK__SfKvVeESIm1K6wc4qho95ShEgEIHcMeta } from "/app/code/web-frontend/modules/database/pages/table/webhooks.vue?macro=true";
import { default as configureDataSync6g1xJlC2uPszI5oyg3R6SOsJJ8f5q4fbqeuTuAd7iJkMeta } from "/app/code/web-frontend/modules/database/pages/table/configureDataSync.vue?macro=true";
import { default as tablerUwsBEewQ3hdPkiChn_yhFAmwTYFAZOt5iv_45xNTDzYgMeta } from "/app/code/web-frontend/modules/database/pages/table.vue?macro=true";
import { default as roottgPryESmaKXYwzmGjGn_URjIuqn6z5BuUlfF0oyM1oAMeta } from "/app/code/web-frontend/modules/database/pages/root.vue?macro=true";
import { default as APIDocstUOfPIk4XUSjHJs_3f6FEOEN9ZDPQZzBq2q7X1Ioh0sMeta } from "/app/code/web-frontend/modules/database/pages/APIDocs.vue?macro=true";
import { default as APIDocsDatabaseJQCXRiJRccsdBMdxQih2xHwCW06ziOOI0dXa6KgAuuEMeta } from "/app/code/web-frontend/modules/database/pages/APIDocsDatabase.vue?macro=true";
import { default as formxNI3_45g8OhOLmPTyYjPi6BaboRKW1sfRSV2kyv4_45tbhUMeta } from "/app/code/web-frontend/modules/database/pages/form.vue?macro=true";
import { default as publicViewPDyKPVmoiYGdKV2kJNUSFs7j0Lwe_ZVAOGgmsnwiK_45MMeta } from "/app/code/web-frontend/modules/database/pages/publicView.vue?macro=true";
import { default as publicViewLoginUnE4LMgUF5Q_aBqP8Y_8DbTUtUyvRv9K04eMhiEt_45NMMeta } from "/app/code/web-frontend/modules/database/pages/publicViewLogin.vue?macro=true";
import { default as dashboard9PeHU0PQFaLbpxr33GGwyq1fOGlDHijbXVOaIoyx30EMeta } from "/app/code/web-frontend/modules/dashboard/pages/dashboard.vue?macro=true";
import { default as pageEditorGm_45Q1PQhAN3skyD8aM5TAe4BaV1zlFIBqnEo_QQLNmAMeta } from "/app/code/web-frontend/modules/builder/pages/pageEditor.vue?macro=true";
import { default as publicPagebhdfaYmJkCJo7DvjCCVVhAv1wlQTTLyLqK7ipuNTQjcMeta } from "/app/code/web-frontend/modules/builder/pages/publicPage.vue?macro=true";
import { default as automationWorkflow130DRUn1lX7EKkMMIutTAGlf5wegFxuG2EQZMSJbx0gMeta } from "/app/code/web-frontend/modules/automation/pages/automationWorkflow.vue?macro=true";
import { default as licenses7XoKNPraBVeeJfZwZwiuVKgLxtikepMJ0mVS7IQwGJgMeta } from "/app/code/premium/web-frontend/modules/baserow_premium/pages/admin/licenses.vue?macro=true";
import { default as licenseLDooPKrMEv_48DQDM76zVr5tvMJNhe_453ygzsoK42GugMeta } from "/app/code/premium/web-frontend/modules/baserow_premium/pages/admin/license.vue?macro=true";
import { default as rootyDVFP8ZGulcpMat_XxwcCnfTKZSGar6UTUQ9ZIR2y4MMeta } from "/app/code/premium/web-frontend/modules/baserow_premium/pages/root.vue?macro=true";
import { default as publicViewic0BLFnKa9D79LeCccGHGRa0RQ5dtQAxboPDW3rHy9wMeta } from "@baserow/modules/database/pages/publicView.vue?macro=true";
export default [
  {
    name: "index",
    path: "",
    component: () => import("/app/code/web-frontend/modules/core/pages/index.vue")
  },
  {
    name: "debug",
    path: "/debug",
    component: () => import("/app/code/web-frontend/modules/core/pages/debug.vue")
  },
  {
    name: "login-pages",
    path: "",
    meta: { ...(loginPagesrSNB1Hoe8vTWUFcV0cYcYoupvjA88I_45Arn2771kVhJUMeta || {}), ...{"middleware":["settings","urlCheck","settings","urlCheck"]} },
    component: () => import("/app/code/web-frontend/modules/core/pages/loginPages.vue"),
    children: [
  {
    name: "login",
    path: "/login",
    meta: { ...(loginfDgo4zzaB0kfmyvxsbEPAp_45N_45oe2IDUFtOeLtqjqPwUMeta || {}), ...{"middleware":["settings","settings"]} },
    component: () => import("/app/code/web-frontend/modules/core/pages/login.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: { ...(signupfrw_45oHT0S_45vVP87g1RilbOJ0wmYIeqbXGYUgStffbSkMeta || {}), ...{"middleware":["settings","settings"]} },
    component: () => import("/app/code/web-frontend/modules/core/pages/signup.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgotPasswordXn3NeNvdY2cT4ItgULlVu64F0ZeZnPLfaZtDUuu9_45hoMeta || {},
    component: () => import("/app/code/web-frontend/modules/core/pages/forgotPassword.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/app/code/web-frontend/modules/core/pages/resetPassword.vue")
  },
  {
    name: "change-email",
    path: "/change-email/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/app/code/web-frontend/modules/core/pages/changeEmail.vue")
  },
  {
    name: "verify-email-address",
    path: "/verify-email-address/:token",
    meta: verifyEmailAddressLAmyeikrtHQ7He_4591wBSXRVNUVqzKgEWW2MdNtiARNYMeta || {},
    component: () => import("/app/code/web-frontend/modules/core/pages/verifyEmailAddress.vue")
  },
  {
    name: "style-guide",
    path: "/style-guide",
    component: () => import("/app/code/web-frontend/modules/core/pages/styleGuide.vue")
  },
  {
    name: "login-saml",
    path: "/login/saml",
    meta: loginWithSAMLay1ZYNDzYNJckGvJiGeyXkhRi1_wpctKqt0_x9E8yh0Meta || {},
    component: () => import("/app/code/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginWithSAML.vue")
  },
  {
    name: "login-error",
    path: "/login/error",
    meta: loginErrorGhNqepWihGnZIr5IPlzWDJ0T_lcXnXEvCIVqCHhM1ioMeta || {},
    component: () => import("/app/code/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginError.vue")
  }
]
  },
  {
    name: "root",
    path: "",
    meta: { ...(rooth0fkNmr8sjr2RiV7G_45HZ_455Pk9PIovUckWDplfdfg8qoMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","settings","authenticated","impersonate","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/app/code/web-frontend/modules/core/pages/root.vue"),
    children: [
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(dashboardnI2dQMFe6DIWjzPVxkHh_45cc8u26ghAQV4MzUoTewIfsMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","dashboardRedirect","settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","dashboardRedirect"]} },
    component: () => import("/app/code/web-frontend/modules/core/pages/dashboard.vue")
  },
  {
    name: "workspace",
    path: "/workspace/:workspaceId",
    meta: { ...(workspaceD1typQeDcfHyRfvySiowhyQboQLp6bNlzxSWzKSaOoMMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","settings","authenticated","impersonate","workspacesAndApplications"]} },
    component: () => import("/app/code/web-frontend/modules/core/pages/workspace.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    component: () => import("/app/code/web-frontend/modules/core/pages/admin/settings.vue")
  },
  {
    name: "admin-health",
    path: "/admin/health",
    meta: { ...(healthPpH9dk4KVAuCIKr2CasVo7pdMMz0XTaJ0ZhIjgIDC60Meta || {}), ...{"middleware":"staff"} },
    component: () => import("/app/code/web-frontend/modules/core/pages/admin/health.vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    component: () => import("/app/code/web-frontend/modules/core/pages/admin/dashboard.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    component: () => import("/app/code/web-frontend/modules/core/pages/admin/users.vue")
  },
  {
    name: "admin-workspaces",
    path: "/admin/workspaces",
    component: () => import("/app/code/web-frontend/modules/core/pages/admin/workspaces.vue")
  },
  {
    name: "settings",
    path: "/workspace/:workspaceId/settings",
    component: () => import("/app/code/web-frontend/modules/core/pages/settings.vue"),
    children: [
  {
    name: "settings-members",
    path: "members",
    component: () => import("/app/code/web-frontend/modules/core/pages/settings/members.vue")
  },
  {
    name: "settings-invites",
    path: "invites",
    component: () => import("/app/code/web-frontend/modules/core/pages/settings/invites.vue")
  },
  {
    name: "settings-teams",
    path: "teams",
    component: () => import("/app/code/enterprise/web-frontend/modules/baserow_enterprise/pages/settings/teams.vue")
  }
]
  },
  {
    name: "admin-auth-providers",
    path: "/admin/auth-providers",
    meta: { ...(authProvidersbymTLAUs7GUcT7g4_45V0i47XAPfstfSmiU01QkfhG7xwMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/app/code/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/authProviders.vue")
  },
  {
    name: "admin-audit-log",
    path: "/admin/audit-log",
    meta: { ...(auditLogn1OFBHT_45pER2yP1OpNxllkXWnVFx_NBBtYUfZIsgTZAMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/app/code/enterprise/web-frontend/modules/baserow_enterprise/pages/auditLog.vue")
  },
  {
    name: "admin-data-scanner",
    path: "/admin/data-scanner",
    meta: { ...(dataScannervr_45XrYUCzaAsCX_452UvcIJHoZrWA6HNNYCyXuDZ17BNUMeta || {}), ...{"middleware":"staff"} },
    redirect: "/admin/data-scanner/scans",
    component: () => import("/app/code/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner.vue"),
    children: [
  {
    name: "admin-data-scanner-scans",
    path: "scans",
    component: () => import("/app/code/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner/scans.vue")
  },
  {
    name: "admin-data-scanner-results",
    path: "results",
    component: () => import("/app/code/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/dataScanner/results.vue")
  }
]
  },
  {
    name: "workspace-audit-log",
    path: "/workspace/:workspaceId/audit-log",
    component: () => import("/app/code/enterprise/web-frontend/modules/baserow_enterprise/pages/auditLog.vue")
  }
]
  },
  {
    name: "workspace-invitation",
    path: "/workspace-invitation/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/app/code/web-frontend/modules/core/pages/workspaceInvitation.vue")
  },
  {
    name: "template",
    path: "/template/:slug",
    component: () => import("/app/code/web-frontend/modules/core/pages/template.vue")
  },
  {
    name: "health-check",
    path: "/_health/:trailing()?",
    component: () => import("/app/code/web-frontend/modules/core/pages/_health.vue")
  },
  {
    name: "notification-redirect",
    path: "/notification/:workspaceId/:notificationId",
    component: () => import("/app/code/web-frontend/modules/core/pages/notificationRedirect.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingy6d12zxbTs2bFArqJTxIQhnHvO8qRnbp_5eINSD8vAoMeta || {},
    component: () => import("/app/code/web-frontend/modules/core/pages/onboarding.vue")
  },
  {
    name: "database-table",
    path: "/database/:databaseId/table/:tableId/:viewId?",
    meta: { ...(tablerUwsBEewQ3hdPkiChn_yhFAmwTYFAZOt5iv_45xNTDzYgMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","tableLoading","selectWorkspaceDatabaseTable","pendingJobs","settings","authenticated","workspacesAndApplications","tableLoading","selectWorkspaceDatabaseTable","pendingJobs"]} },
    component: () => import("/app/code/web-frontend/modules/database/pages/table.vue"),
    children: [
  {
    name: "database-table-row",
    path: "row/:rowId",
    component: () => import("/app/code/web-frontend/modules/core/components/RouterViewPlaceholder.vue")
  },
  {
    name: "database-table-open-webhooks",
    path: "webhooks",
    component: () => import("/app/code/web-frontend/modules/database/pages/table/webhooks.vue")
  },
  {
    name: "database-table-open-configure-data-sync",
    path: "configure-data-sync/:selectedPage?",
    component: () => import("/app/code/web-frontend/modules/database/pages/table/configureDataSync.vue")
  }
]
  },
  {
    name: "database-root",
    path: "",
    meta: { ...(roottgPryESmaKXYwzmGjGn_URjIuqn6z5BuUlfF0oyM1oAMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","pendingJobs","settings","authenticated","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/app/code/web-frontend/modules/database/pages/root.vue")
  },
  {
    path: "/api/docs",
    name: "database-api-docs-redirect",
    redirect: "/api-docs"
  },
  {
    path: "/api/docs/database/:databaseId",
    name: "database-api-docs-details-redirect",
    redirect: "/api-docs/database/:databaseId"
  },
  {
    name: "database-api-docs",
    path: "/api-docs",
    meta: { ...(APIDocstUOfPIk4XUSjHJs_3f6FEOEN9ZDPQZzBq2q7X1Ioh0sMeta || {}), ...{"middleware":["workspacesAndApplications","workspacesAndApplications"]} },
    alias: ["/api/docs"],
    component: () => import("/app/code/web-frontend/modules/database/pages/APIDocs.vue")
  },
  {
    name: "database-api-docs-detail",
    path: "/api-docs/database/:databaseId",
    meta: {"middleware":["workspacesAndApplications","workspacesAndApplications"]},
    component: () => import("/app/code/web-frontend/modules/database/pages/APIDocsDatabase.vue")
  },
  {
    name: "database-table-form",
    path: "/form/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/app/code/web-frontend/modules/database/pages/form.vue")
  },
  {
    name: "database-public-grid-view",
    path: "/public/grid/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/app/code/web-frontend/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-gallery-view",
    path: "/public/gallery/:slug",
    component: () => import("/app/code/web-frontend/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-view-auth",
    path: "/public/auth/:slug",
    meta: { ...(publicViewLoginUnE4LMgUF5Q_aBqP8Y_8DbTUtUyvRv9K04eMhiEt_45NMMeta || {}), ...{"layout":"login"} },
    component: () => import("/app/code/web-frontend/modules/database/pages/publicViewLogin.vue")
  },
  {
    name: "dashboard-application",
    path: "/dashboard/:dashboardId",
    meta: { ...(dashboard9PeHU0PQFaLbpxr33GGwyq1fOGlDHijbXVOaIoyx30EMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","dashboardLoading","settings","authenticated","workspacesAndApplications","dashboardLoading"]} },
    component: () => import("/app/code/web-frontend/modules/dashboard/pages/dashboard.vue")
  },
  {
    name: "builder-page",
    path: "/builder/:builderId/page/:pageId",
    meta: { ...(pageEditorGm_45Q1PQhAN3skyD8aM5TAe4BaV1zlFIBqnEo_QQLNmAMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","selectWorkspaceBuilderPage","pendingJobs","settings","authenticated","workspacesAndApplications","selectWorkspaceBuilderPage","pendingJobs"]} },
    component: () => import("/app/code/web-frontend/modules/builder/pages/pageEditor.vue")
  },
  {
    name: "application-builder-page",
    path: "/:pathMatch(.*)*",
    meta: {"publishedBuilderRoute":true},
    component: () => import("/app/code/web-frontend/modules/builder/pages/publicPage.vue")
  },
  {
    name: "builder-health-check",
    path: "/_health",
    meta: {"publishedBuilderRoute":true},
    component: () => import("/app/code/web-frontend/modules/core/pages/_health.vue")
  },
  {
    name: "application-builder-preview",
    path: "/builder/:builderId/preview/:pathMatch(.*)*",
    component: () => import("/app/code/web-frontend/modules/builder/pages/publicPage.vue")
  },
  {
    name: "automation-workflow",
    path: "/automation/:automationId/workflow/:workflowId",
    meta: { ...(automationWorkflow130DRUn1lX7EKkMMIutTAGlf5wegFxuG2EQZMSJbx0gMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","pendingJobs","settings","authenticated","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/app/code/web-frontend/modules/automation/pages/automationWorkflow.vue")
  },
  {
    name: "premium-root",
    path: "",
    meta: { ...(rootyDVFP8ZGulcpMat_XxwcCnfTKZSGar6UTUQ9ZIR2y4MMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","pendingJobs","settings","authenticated","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/app/code/premium/web-frontend/modules/baserow_premium/pages/root.vue"),
    children: [
  {
    name: "admin-licenses",
    path: "/admin/licenses",
    meta: { ...(licenses7XoKNPraBVeeJfZwZwiuVKgLxtikepMJ0mVS7IQwGJgMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/app/code/premium/web-frontend/modules/baserow_premium/pages/admin/licenses.vue")
  },
  {
    name: "admin-license",
    path: "/admin/license/:id",
    meta: { ...(licenseLDooPKrMEv_48DQDM76zVr5tvMJNhe_453ygzsoK42GugMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/app/code/premium/web-frontend/modules/baserow_premium/pages/admin/license.vue")
  }
]
  },
  {
    name: "database-public-kanban-view",
    path: "/public/kanban/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("@baserow/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-calendar-view",
    path: "/public/calendar/:slug",
    component: () => import("@baserow/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-timeline-view",
    path: "/public/timeline/:slug",
    component: () => import("@baserow/modules/database/pages/publicView.vue")
  }
]